module.exports = __webpack_public_path__ + "static/media/sq_jnt.9fd49a8d.png";